/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sign_UpInputs */

const en_sign_up = /** @type {(inputs: Sign_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign Up`)
};

const nl_sign_up = /** @type {(inputs: Sign_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registreren`)
};

/**
* | output |
* | --- |
* | "Sign Up" |
*
* @param {Sign_UpInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const sign_up = /** @type {((inputs?: Sign_UpInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sign_UpInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_sign_up(inputs)
	return en_sign_up(inputs)
});